{
	"title": "Start list",
	"count_one": "{{count}} on the list",
	"count_other": "{{count}} on the list",
	"swapRule": "To swap two lanes, change both lane numbers, then save. A slot keeps its competitor: moving a competitor into a slot another one holds is refused.",
	"swapRuleTeam": "Pick each team's side, then save. A slot keeps its team: moving a team into a slot another one holds is refused.",
	"swapRuleCorner": "Pick each competitor's corner, then save. A slot keeps its competitor: moving one into a slot another holds is refused.",
	"swapRuleOrder": "To swap two competitors, change both order numbers, then save. A slot keeps its competitor: moving one into a slot another holds is refused.",
	"swapRuleSeq": "Seq 1 plays on top, Seq 2 below. To swap them, change both numbers, then save. A slot keeps its competitor: moving one into a slot another holds is refused.",
	"swapRuleLifts": "Seq is the order of the list. Lot No. breaks ties in the lifting order: at the same weight, the lower lot lifts first. Edit both, then save.",
	"col": {
		"lane": "Lane",
		"pos": "Pos.",
		"order": "Order",
		"seq": "Seq",
		"lot": "Lot No.",
		"bib": "Bib",
		"bodyweight": "Bodyweight (kg)",
		"entry": "Entry total (kg)",
		"side": "Side",
		"competitor": "Competitor",
		"team": "Team",
		"seed": "Seed",
		"state": "State",
		"actions": "Action"
	},
	"input": {
		"lane": "Lane for {{name}}",
		"pos": "Home or away for {{name}}",
		"order": "Start order for {{name}}",
		"lot": "Lot number for {{name}}",
		"bib": "{{label}} for {{name}}",
		"ownBib": "{{bib}} is the athlete's number for this event (set on the athlete page or the entry). Type one here only to use another in this meet.",
		"bodyweight": "Bodyweight for {{name}}",
		"entry": "Entry total for {{name}}",
		"side": "Side for {{name}}"
	},
	"waitingFor": "Waiting for",
	"source": {
		"winnerOf": "Winner of {{meet}}",
		"loserOf": "Loser of {{meet}}",
		"rankOfMeet": "Rank {{rank}} in {{meet}}",
		"rankOfPool": "Rank {{rank}} in {{phase}}, pool {{pool}}",
		"rankOfPhase": "Rank {{rank}} in {{phase}}",
		"unknown": "Not decided yet"
	},
	"state": {
		"clean": "On the list",
		"new": "Added",
		"edited": "Changed",
		"removed": "Removed",
		"holdsResult": "Has a result"
	},
	"remove": "Remove",
	"removeName": "Remove {{name}}",
	"keep": "Keep",
	"keepName": "Keep {{name}}",
	"cannotRemove": "This slot holds a result, so it cannot be removed.",
	"competitorStatus": {
		"WITHDRAWN": "Withdrawn",
		"DISQUALIFIED": "Disqualified"
	},
	"issue": {
		"laneDuplicate": "This lane is used twice.",
		"laneTooLong": "A lane has at most {{max}} characters.",
		"lotDuplicate": "This lot number is used twice.",
		"lotTooLong": "A lot number has at most {{max}} characters.",
		"bibDuplicate": "This number is used twice.",
		"bibTooLong": "A number has at most {{max}} characters.",
		"entryTooLong": "An entry total has at most {{max}} characters.",
		"bodyweightFormat": "Bodyweight is in kilograms: above 0, at most {{max}}, up to two decimals (for example 72.85).",
		"posDuplicate": "Home or Away is used twice.",
		"orderFormat": "Start order is a whole number.",
		"orderRange": "Start order is from 1 to {{max}}.",
		"orderDuplicate": "This start order is used twice.",
		"sideDuplicate": "This side is used twice.",
		"sideFormat": "Use letters, digits or _ for the side (for example HOME)."
	},
	"conflict": {
		"removedWithResult": "Holds a result on the server, so it cannot be removed.",
		"competitorChangeBlocked": "Holds a result or a line-up, so its competitor cannot change.",
		"unknownCompetitor": "Not entered in this event.",
		"notEntered": "This competitor's entry is no longer active.",
		"invalidSource": "Its source is not part of this event.",
		"moved": "This competitor still holds another slot here. Change lanes instead, or remove the other slot.",
		"foreignSlot": "This slot belongs to another meet. Reload the page.",
		"byeBlocked": "Won on a bye, so no one else can join this meet. Remove the bye first."
	},
	"banner": {
		"official": "This meet is official, so its start list is frozen. Change the Meet status to change it.",
		"locked": "The medal desk has locked this event. Nothing beneath it can change until it is unlocked.",
		"stale": "Someone else saved this start list after you started editing.",
		"staleHint": "Keep mine saves your list over theirs. Take theirs throws your edits away.",
		"refused": "The start list was not saved. Fix the rows marked below and save again.",
		"offline": "Not saved: the server could not be reached. Your edits are still here. Try again.",
		"invalid": "The start list was not saved: the server did not accept some values.",
		"localInvalid": "Fix the rows marked below before saving."
	},
	"sync": {
		"button": "Sync from {{phase}}",
		"buttonTop_one": "Sync the winner of {{phase}}",
		"buttonTop_other": "Sync top {{count}} from {{phase}}",
		"done_one": "{{count}} qualifier placed from {{phase}}. Check the lane, then press Save.",
		"done_other": "{{count}} qualifiers placed from {{phase}}. Check the lanes, then press Save.",
		"loadFailed": "Could not read the {{phase}} standings. Try again.",
		"marksFailed": "The start list is saved, but the qualifiers of {{phase}} could not be marked. Use Advance on the {{phase}} standings.",
		"refused": {
			"NO_COUNT": "{{phase}} does not say how many go through. Set Next stage on the meet's details, or add them by hand.",
			"POOLS": "{{phase}} is drawn in groups. Use Advance on the {{phase}} standings to choose who goes through.",
			"NOT_FINISHED": "Not every meet of {{phase}} has its results yet: {{meets}}. Make them unofficial or official first.",
			"TIE_AT_CUT": "More competitors share the last qualifying place than there are places. Break the tie, then use Advance on the {{phase}} standings.",
			"BY_PLACE_OVER_COUNT": "More of {{phase}} qualify on their heat place (Q) than go through in all. Lower \"from each heat\" or raise how many go on in the meet's details.",
			"NONE": "Nobody in {{phase}} has a result yet."
		}
	},
	"empty": {
		"title": "Nobody is on this start list yet",
		"body": "Add competitors from the event's entries below.",
		"bodyTeam": "Add teams from the event's entries below."
	},
	"save": {
		"pending_one": "{{count}} change not saved",
		"pending_other": "{{count}} changes not saved",
		"button": "Save start list",
		"discard": "Discard changes",
		"saved": "Start list saved"
	},
	"leave": {
		"title": "Leave without saving the start list?",
		"body": "Your changes to this start list have not been saved. They will be lost.",
		"confirm": "Leave and lose changes",
		"stay": "Stay on this page"
	},
	"add": {
		"title": "Available athletes",
		"titleTeam": "Available teams",
		"hint": "Everyone entered in this event. Tick to put on this meet’s list, untick to take off, then save the start list.",
		"hintTeam": "Every team entered in this event. Tick to put on this meet’s list, untick to take off, then save. A match takes two.",
		"search": "Search by name or NOC",
		"searchTeam": "Search by country or code",
		"clear": "Clear search",
		"addName": "Add {{name}}",
		"entryMark": "Entry {{mark}}",
		"seed": "Seed {{seed}}",
		"none": "Nobody is entered in this event yet. Athletes appear here as soon as their NOC shortlists them in GMS.",
		"noMatch": "No entered competitor matches this search.",
		"more": "Show more",
		"advanced": "Went through to this phase",
		"notAdvanced": "Nobody has been advanced to this stage yet, so every entrant is listed, including those who did not qualify. Press Sync from {{phase}} above, or open Standings on {{phase}} and use Advance.",
		"selectedOf": "{{n}} / {{total}} selected",
		"selectedCount": "{{n}} selected",
		"removeName": "Take {{name}} off the list",
		"holdsResult": "Has a result in this meet",
		"full": "This match already has its two teams",
		"inMeet": "In meet {{meet}}",
		"inOtherMeet": "In another meet of this stage",
		"noneTeam": "No team is entered in this event yet."
	},
	"squad": {
		"title": "Line-ups",
		"minimize": "Minimize",
		"expand": "Show line-ups",
		"hint": "Tap Starting or Sub for each player, then tick the goalkeeper (GK) and the captain. Numbers stay with the team for all its matches; one typed on the athlete page fills in by itself.",
		"hintNoGk": "Tap Starting or Sub for each player, then tick the captain. Numbers stay with the team for all its matches; one typed on the athlete page fills in by itself.",
		"col": {
			"shirt": "Shirt No.",
			"player": "Player",
			"status": "Status",
			"gk": "GK",
			"position": "Position",
			"captain": "Captain"
		},
		"status": {
			"start": "Starting",
			"sub": "Sub",
			"out": "Out"
		},
		"group": {
			"start_one": "Starting · {{count}}",
			"start_other": "Starting · {{count}}",
			"sub_one": "Substitutes · {{count}}",
			"sub_other": "Substitutes · {{count}}",
			"out_one": "Not in the squad · {{count}}",
			"out_other": "Not in the squad · {{count}}"
		},
		"shirtFor": "{{label}} for {{name}}",
		"captainFor": "{{name}} is captain",
		"statusFor": "Place of {{name}} in this match",
		"gkFor": "{{name}} is the goalkeeper",
		"positionFor": "Position of {{name}}",
		"holdsEvents": "Has goals or cards in this match, so stays in the squad.",
		"save": "Save line-up",
		"undo": "Undo changes",
		"saved": "Numbers saved",
		"shirtDuplicate": "Two players have the same number.",
		"shirtTooLong": "A number has at most {{max}} characters.",
		"shirtTaken": "Not saved: number {{bibs}} is already worn by another player of this team.",
		"rosterChanged": "Not saved: this team's roster has changed. Reload the page.",
		"offline": "Not saved: the server could not be reached. Your changes are still here.",
		"noRoster": "Nobody is on this team's roster yet.",
		"inSquad_one": "{{count}} in the squad",
		"inSquad_other": "{{count}} in the squad",
		"startingCount_one": "{{count}} starting",
		"startingCount_other": "{{count}} starting",
		"starters": "{{n}} / {{max}} starting",
		"subsOf": "{{n}} / {{max}} substitutes",
		"subsCount_one": "{{count}} substitute",
		"subsCount_other": "{{count}} substitutes",
		"overLimit": "Matchday squad {{n}} / {{max}}: over the limit",
		"noGk": "No starting goalkeeper",
		"manyGk": "More than one starting goalkeeper",
		"seqSide": "Seq {{n}}"
	},
	"rubbers": {
		"synced_one": "The tie’s teams were copied to {{count}} match.",
		"synced_other": "The tie’s teams were copied to {{count}} matches.",
		"notSynced": "These matches keep their own teams (already played, or not saved): {{meets}}"
	},
	"members": {
		"show": "Show athletes",
		"hide": "Hide athletes",
		"showFor": "Show the athletes of {{name}}",
		"hideFor": "Hide the athletes of {{name}}",
		"rosterFailed": "Could not load this team's roster.",
		"col": {
			"athlete": "Athlete",
			"bib": "Bib"
		},
		"bibFor": "{{label}} of {{name}}",
		"bibHint": "A number stays with the athlete in every meet of this team; one typed on the athlete page fills in by itself.",
		"save": "Save numbers",
		"saved": "Numbers saved",
		"bibTaken": "Not saved: number {{bibs}} is already worn by another athlete of this team.",
		"issue": {
			"bibTooLong": "A number has at most {{max}} characters.",
			"bibDuplicate": "Two athletes have the same number."
		}
	},
	"teams": {
		"title": "Teams",
		"hint": "Open a team to see its athletes and their bibs."
	}
}
